/**
 * Check if the current time zone is in Europe
 * @returns boolean
 *
 * @see https://stackoverflow.com/a/74814624
 */
export const isInEu = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone.indexOf('Europe') === 0
